/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addCash} from '../api'

export const useMutationAddCash = createReactQueryMutationHook('addCash', addCash)
